function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "current",
  stroke: "current"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M18.3,542.7L3.3,527.7v-5.3l16.4,16.4l18.7-17v5.3l-16.1,14.4l1,1h15.1v3.9h-35v-3.9H18.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M16.5,517.7v-3.8h2.6c-2.1-1.7-3.2-3.8-3.2-6.2c0-2.5,0.8-4.5,2.4-5.8c1.3-1.1,3.4-1.7,6.4-1.7h13.6v3.8H25.5 c-2.3,0-3.8,0.4-4.7,1c-0.9,0.7-1.3,1.9-1.3,3.6c0,3.8,2.4,5.4,8,5.4h10.9v3.8H16.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M16,483c0-6.4,5.1-11.5,11.5-11.5c6.5,0,11.4,5.1,11.4,11.6c0,6.4-5.1,11.4-11.6,11.4 C21.4,494.5,16,489.7,16,483z M35.5,483.1c0-4.5-3.3-7.8-8-7.8s-8.1,3.3-8.1,7.8c0,4.4,3.5,7.7,7.9,7.7 C32.1,490.7,35.5,487.5,35.5,483.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M16.5,465.5l14.8-6.5l-16.4-6.8l16.4-6.8L16.5,439v-4.2l23.3,10.8l-16.2,6.7l16.2,6.7l-23.3,10.7V465.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M0,427h29.5c4.6,0,6-1.3,6-4.6l3.4,0.8c0,4.3-2.2,7.6-8.8,7.6H0V427z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M28.2,415.3c4.5-0.2,7.3-3,7.3-6.9c0-2.9-1.2-4.7-4.6-6.7l1.8-3.2c4.1,2.4,6.2,5.7,6.2,10 c0,6.4-4.7,10.7-11.4,10.7c-6.8,0-11.5-4.2-11.5-10.5c0-6.3,4.6-10.4,11.5-10.4h0.7V415.3z M25,402.3c-3.4,0.7-5.6,3.2-5.6,6.4 c0,3.2,2.4,5.9,5.6,6.4V402.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M0,376v-3.8h38.3v3.8h-3c2.4,2,3.6,4.5,3.6,7.6c0,6-4.9,10.5-11.5,10.5c-6.6,0-11.4-4.4-11.4-10.4 c0-3,1.2-5.6,3.6-7.6H0z M35.5,383c0-4.4-3.4-7.3-8.1-7.3c-4.6,0-8,3-8,7.2c0,3.9,3.2,7.2,7.9,7.2C32,390.2,35.5,387.3,35.5,383z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M16.5,344.6h21c3.1,0,6,0.2,8.3,1.7c2.7,1.8,4.6,4.4,4.6,9.1c0,6-4.1,10.6-10,10.6v-3.7 c4.4-0.4,6.6-2.7,6.6-7c0-4.6-2.8-7-8.6-7h-3.1c2.4,2.1,3.6,4.7,3.6,7.7c0,5.9-5,10.4-11.4,10.4c-6.6,0-11.5-4.6-11.5-10.5 c0-3,1.2-5.5,3.6-7.5h-3.1V344.6z M35.5,355.5c0-4.3-3.4-7.3-8-7.3c-4.8,0-8.1,3.1-8.1,7.3c0,4.1,3.3,7.2,8.1,7.2 S35.5,359.7,35.5,355.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M28.2,334.6c4.5-0.2,7.3-3,7.3-6.9c0-2.9-1.2-4.7-4.6-6.7l1.8-3.2c4.1,2.4,6.2,5.7,6.2,10 c0,6.4-4.7,10.7-11.4,10.7c-6.8,0-11.5-4.2-11.5-10.5c0-6.3,4.6-10.4,11.5-10.4h0.7V334.6z M25,321.6c-3.4,0.7-5.6,3.2-5.6,6.4 c0,3.2,2.4,5.9,5.6,6.4V321.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M6.9,278.4v14.2h10.4v-13.8H21v13.8h13.7v-14.2h3.7v18.2h-35v-18.2H6.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M26.7,266.1L16.5,274v-4.6l7.4-5.7l-7.4-5.7v-4.6l10.2,8l11.6-9.1v4.5l-8.9,6.9l8.9,6.9v4.7L26.7,266.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M23,232.2c-2.6,2.4-3.6,4.1-3.6,6.9c0,4.3,3.4,7.7,8.1,7.7s8-3.3,8-7.6c0-2.9-0.9-4.4-3.8-7.1h5 c1.5,2.3,2.2,4.7,2.2,7c0,6.4-4.9,11.6-11.4,11.6c-6.5,0-11.5-4.9-11.5-11.6c0-2.4,0.7-4.6,2-6.8H23z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M0,225.8v-3.8h19c-2-1.7-3-3.8-3-6.2c0-2.5,0.8-4.4,2.4-5.8c1.3-1.2,3.4-1.7,6.4-1.7h13.5v3.7H25 c-4,0-5.6,1.3-5.6,4.6c0,3.9,2.4,5.5,8,5.5h10.9v3.8H0z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M16.5,184.5v-3.8h21.8v3.8h-3c2.4,2,3.6,4.6,3.6,7.5c0,6-4.9,10.5-11.6,10.5c-6.7,0-11.4-4.4-11.4-10.4 c0-3,1.2-5.6,3.6-7.6H16.5z M35.5,191.6c0-4.4-3.4-7.3-8.1-7.3c-4.7,0-8,3-8,7.2c0,4,3.3,7.2,7.9,7.2 C32,198.8,35.5,195.8,35.5,191.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M16.5,173.6v-3.8h2.6c-2.1-1.7-3.2-3.8-3.2-6.2c0-2.5,0.8-4.5,2.4-5.8c1.3-1.1,3.4-1.7,6.4-1.7h13.6v3.8H25.5 c-2.3,0-3.8,0.4-4.7,1c-0.9,0.7-1.3,1.9-1.3,3.6c0,3.8,2.4,5.4,8,5.4h10.9v3.8H16.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M16.5,128.6h21c3.1,0,6,0.2,8.3,1.7c2.7,1.8,4.6,4.4,4.6,9.1c0,6-4.1,10.6-10,10.6v-3.7 c4.4-0.4,6.6-2.7,6.6-7c0-4.6-2.8-7-8.6-7h-3.1c2.4,2.1,3.6,4.7,3.6,7.7c0,5.9-5,10.4-11.4,10.4c-6.6,0-11.5-4.6-11.5-10.5 c0-3,1.2-5.5,3.6-7.5h-3.1V128.6z M35.5,139.5c0-4.3-3.4-7.3-8-7.3c-4.8,0-8.1,3.1-8.1,7.3c0,4.1,3.3,7.2,8.1,7.2 S35.5,143.7,35.5,139.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M28.2,118.6c4.5-0.2,7.3-3,7.3-6.9c0-2.9-1.2-4.7-4.6-6.7l1.8-3.2c4.1,2.4,6.2,5.7,6.2,10 c0,6.4-4.7,10.7-11.4,10.7c-6.8,0-11.5-4.2-11.5-10.5c0-6.3,4.6-10.4,11.5-10.4h0.7V118.6z M25,105.5c-3.4,0.7-5.6,3.2-5.6,6.4 c0,3.2,2.4,5.9,5.6,6.4V105.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M3.3,80.5v-7.2c0-3.1,0.4-5.8,1.2-8c0.8-2.2,2.1-4.2,3.9-6c3.3-3.3,7.4-4.9,12.4-4.9c5,0,9.1,1.7,12.4,5 c1.8,1.9,3.2,3.9,3.9,6c0.8,2.1,1.2,4.8,1.2,8v7.1H3.3z M34.7,76.6v-3.4c0-4.6-1.3-8.3-4-10.9c-2.6-2.6-5.9-3.9-9.8-3.9 c-3.9,0-7.2,1.3-9.9,3.9c-2.7,2.6-4,6.3-4,11v3.4H34.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M16.5,31.6v-3.8h21.8v3.8h-3c2.4,2,3.6,4.6,3.6,7.5c0,6-4.9,10.5-11.6,10.5c-6.7,0-11.4-4.4-11.4-10.4 c0-3,1.2-5.6,3.6-7.6H16.5z M35.5,38.7c0-4.4-3.4-7.3-8.1-7.3c-4.7,0-8,3-8,7.2c0,4,3.3,7.2,7.9,7.2C32,45.8,35.5,42.9,35.5,38.7z "
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M36.3,13.7l-19.8,10v-4.4l15.7-7.7L16.5,4.6V0.4l34.1,16.1v4.3L36.3,13.7z"
})), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M731.2,0.4H243L69.9,225.7v84l184.7,236.9h476.6c150.7,0,268.8-129.7,268.8-273.1 C1000,128.6,880.5,0.4,731.2,0.4z M201.7,259L379.2,47.2v427.2L201.7,259z M695.7,426.4H521.2v-94.2h159.4V211.9H521.2v-91.3h174.6 c97.1,0,155.8,65.2,155.8,152.9C851.5,361.9,795,426.4,695.7,426.4z"
}));

function SvgKedLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 547",
    style: {
      enableBackground: "new 0 0 1000 547"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKedLogo);
export default __webpack_public_path__ + "static/media/KedLogo.852b585b.svg";
export { ForwardRef as ReactComponent };